// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServicesBannersForHome {
    width: 100%;
    box-sizing: border-box;
    padding: 32px 16px;
}

.ServicesBannersForHome-Container,
.ServicesBannersForHome-row{
    width: 100%;
    max-width: 90vw;
    margin: 0 auto;
    padding: 0 16px;
    box-sizing: border-box;
}

.ServicesBannersForHome-row {
    max-width: 100%;
    padding: 0;
}

@media only screen and (min-width: 576px){
    .ServicesBannersForHome-Container {
        max-width: 576px;
    }
}

@media only screen and (min-width: 768px){
    .ServicesBannersForHome-Container {
        max-width: 768px;
    }
}

@media only screen and (min-width: 992px){
    .ServicesBannersForHome-Container {
        max-width: 992px;
    }
}

@media only screen and (min-width: 1200px){
    .ServicesBannersForHome-Container {
        max-width: 1200px;
    }
}

@media only screen and (min-width: 1400px){
    .ServicesBannersForHome-Container {
        max-width: 1400px;
    }
}

`, "",{"version":3,"sources":["webpack://./src/components/ServicesBannersForHome/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;IACX,eAAe;IACf,cAAc;IACd,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".ServicesBannersForHome {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 32px 16px;\n}\n\n.ServicesBannersForHome-Container,\n.ServicesBannersForHome-row{\n    width: 100%;\n    max-width: 90vw;\n    margin: 0 auto;\n    padding: 0 16px;\n    box-sizing: border-box;\n}\n\n.ServicesBannersForHome-row {\n    max-width: 100%;\n    padding: 0;\n}\n\n@media only screen and (min-width: 576px){\n    .ServicesBannersForHome-Container {\n        max-width: 576px;\n    }\n}\n\n@media only screen and (min-width: 768px){\n    .ServicesBannersForHome-Container {\n        max-width: 768px;\n    }\n}\n\n@media only screen and (min-width: 992px){\n    .ServicesBannersForHome-Container {\n        max-width: 992px;\n    }\n}\n\n@media only screen and (min-width: 1200px){\n    .ServicesBannersForHome-Container {\n        max-width: 1200px;\n    }\n}\n\n@media only screen and (min-width: 1400px){\n    .ServicesBannersForHome-Container {\n        max-width: 1400px;\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
